module.exports = "<div id=\"main\">\n  <div class=\"fof\">\n    <h1>Oops..</h1>\n    <h1>Something went wrong; or the URL doesn't exist.</h1>\n    <div>\n      <a class=\"btn btn-blue\" href=\"/\">\n        <i class=\"material-icons\">refresh</i>Try Again\n      </a>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/builder-url-not-found/builder-url-not-found.component.html
// module id = ../../../../../src/app/mnt-public-quote/builder-url-not-found/builder-url-not-found.component.html
// module chunks = mnt-public-quote.module